import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import {
    Button,
    Row,
} from 'yurstrap';

import {
    setCookiePreferences,
    getAcceptedCookiesSelector,
} from '../reduxModules/ConsentManagementPlatform';

const propTypes = {
    AppActions: PropTypes.shape({
        setCookiePreferences: PropTypes.func.isRequired,
    }).isRequired,
    cookieContainer: PropTypes.array.isRequired,
};

export class CMPFooter extends Component {

    constructor(props) {
        super(props);
        this.onSave = this.onSave.bind(this);
    }

    onSave() {
        const { AppActions } = this.props;
        AppActions.setCookiePreferences();
    }

    render() {
        return (
            <Row
                noCol
                align="right"
                className="mt-4"
            >
                <Button
                    color="premium"
                    className="c-btn--premium"
                    onClick={this.onSave}
                >
                    Quitter
                </Button>
            </Row>
        );
    }

}

CMPFooter.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        cookieContainer: getAcceptedCookiesSelector(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            setCookiePreferences,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CMPFooter);
